const getSubCategories = ( form, element ) => {

    let subSelect = element.parentElement.nextElementSibling;
    const subSelectAll = document.querySelectorAll('.sub-category');
    
    if( subSelectAll ) {
        subSelectAll.forEach( item => {
            item.innerHTML = '';
            item.classList.add('hidden');
        })
    }

    if( !subSelect ) {
        return false;
    }

    form.append('nonce', svn_filter_args.nonce);
    form.append('type', 'getSubCategories');
    
    if( svn_filter_args.current ) {
        // form.append('current', svn_filter_args.current);
    }
    

    fetch( `${ svn_filter_args.ajax_url }?action=${ svn_filter_args.action }` , {
        method: 'POST',
        headers: {
        },
        body: form
    })
    .then((response) => response.json())
    .then((data) => {
        if( data.return ) {
            subSelect.innerHTML = data.return;
        }
        subSelect.classList.remove('hidden');
    })
    .catch((error) => {
        console.error('Error:', error);
    });

}

export default getSubCategories;